import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppStore } from './store/appStore';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';

export default function App() {
  const { i18n } = useTranslation();
  const { language, setLanguage } = useAppStore();

  useEffect(() => {
    // Initialize language from localStorage on app load
    const savedLanguage = localStorage.getItem('language') || 'ar';
    
    if (i18n.language !== savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
    
    if (language !== savedLanguage) {
      setLanguage(savedLanguage);
    }
    
    // Set document attributes
    document.documentElement.lang = savedLanguage;
    document.documentElement.dir = savedLanguage === 'ar' || savedLanguage === 'fa' || savedLanguage === 'ur' ? 'rtl' : 'ltr';
  }, []);

  useEffect(() => {
    // Sync language changes
    document.documentElement.lang = language;
    document.documentElement.dir = language === 'ar' || language === 'fa' || language === 'ur' ? 'rtl' : 'ltr';
    i18n.changeLanguage(language);
    localStorage.setItem('language', language);
  }, [language, i18n]);

  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dashboard" element={<Dashboard />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}
